import React, { useEffect } from "react";
import Alert from '@mui/material/Alert';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Stack from '@mui/material/Stack';

// ModalMessageAlert: Componente que renderiza un mensaje en la parte superior de la pantalla.

const ModalMessageAlert = ({ open, message, onClose }) => {

  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        onClose();
      }, 2000);
      return () => clearTimeout(timer); // Cleanup the timer if the component is unmounted
    }
  }, [open, onClose]);

  if (!open) return null; // Don't render anything if the alert is not open

  return (
    <div style={{ width: '100%', position: "absolute", top: "80px", display: "flex", justifyContent: "center" }}>
      <Stack spacing={2}>
        <Alert
          iconMapping={{
            success: <CheckCircleOutlineIcon fontSize="inherit" />,
          }}
        >
          {message}
        </Alert>
      </Stack>
    </div>
  );
};

export default ModalMessageAlert;
